import React, { Fragment, useState, useEffect } from 'react';
import classNames from 'classnames';
import { Check, X } from "@phosphor-icons/react";

export default function Button(props) {

    const {
        component,
        color,
        children,
        onClick,
        to,
        submit,
        type: typeProp,
        target,
        disabled,
        border,
        wAuto,
        small,
        center,
        left,
        right,
        status: statusProp,
        className = ""
    } = props;

    const [ status, setStatus ] = useState(statusProp?.toLowerCase() || 'idle');

    const idle = status === 'idle';
    const success = status === 'success';
    const error = status === 'error';
    const loading = status === 'loading' || status === 'pending';

    let type = typeProp || 'button';
    if(submit) type = 'submit';

    useEffect(() => {
        if(statusProp === status) return;
        setStatus(statusProp?.toLowerCase() || 'idle');
        if(statusProp === 'success' || statusProp === 'error') {
            setTimeout(() => {
                setStatus('idle');
            }, 1500);
        }
    }, [statusProp, status]);

    let classes = typeof className === "string" ? className.split(" ").reduce((acc, item) => {
        acc[item] = true
        return acc
    }, {}) : className;

    const Classes = classNames({
        "border flex justify-center px-4 text-md focus:ring focus:ring-primary focus:ring-opacity-20 transition-all": true,
        "lg:mx-auto": center,
        "w-full": !wAuto,
        "w-full md:w-auto": wAuto,
        "rounded-xl py-3 h-50 font-medium lg:max-w-340": !small,
        "rounded-2xl py-1": !!small,
        "cursor-not-allowed opacity-40": disabled,
        "text-white": !border && color !== 'light',
        [`text-${color}`]: border && color,
        [`bg-${color}`]: color && !border,
        "bg-primary border-primary hover:bg-primaryhover hover:border-primaryhover": !color && !border,
        "bg-green border-green hover:bg-greenhover hover:border-greenhover": color === 'green',
        "bg-red border-red hover:bg-redhover hover:border-redhover": error || color === 'red',
        [`hover:bg-${color} bg-opacity-20`]: color && border,
        'bg-transparent': border,
        'hover:bg-extralightprimary hover:border-gray': border && !color,
        'items-center justify-center text-center': !left && !right,
        'items-left justify-start text-left': left,
        'items-right justify-end text-right': right,
        ...classes
    })

    const Component = component || "button";

    return (
        <Component
            className={Classes}
            to={to}
            onClick={onClick ? onClick : undefined}
            submit={submit ? "submit" : undefined}
            type={type}
            href={component === "a" ? to : undefined}
            target={target || '_self'}
            disabled={disabled}
        >
            {loading &&
                <svg className="animate-spin -ml-1 mr-3 h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-20 stroke-white" cx="12" cy="12" r="10" strokeWidth="4"></circle>
                    <path className="opacity-100 fill-white" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
                </svg>
            }

            {success &&
                <Check className="h-5 w-5 fill-white" />
            }

            {error &&
                <X className="h-5 w-5 fill-white" />
            }

            {idle &&
                <Fragment>
                    {children}
                </Fragment>
            }
        </Component>
    )
}
